<ion-button (click)="presentPopover($event)">
	<ion-icon src="../../../assets/topgolf/burger-button.svg"></ion-icon>
</ion-button>
